// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select-module__root--KcD4h:not(li) {
  position: relative;
  display: inline-flex;
  min-width: 108px;
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.8125rem; /* 13px */
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
}

.Select-module__root--KcD4h:not(li)::after {
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  height: 4px;
  content: '';
}

.Select-module__box--LTGr8 {
  box-sizing: border-box;
  display: inline-flex;
  width: 100%;
  height: 100%;
  align-items: center;
  gap: 0;
  padding-right: 10px;
  padding-left: 14px;
  border: 1px solid var(--chaek-color-border-source-e0e0e3);
  border-radius: 999px;
  background-color: var(--chaek-color-surface-canvas);
  white-space: nowrap;
  cursor: pointer;
}

.Select-module__box--LTGr8::after {
  width: 7px;
  height: 7px;
  margin-right: 5.5px;
  margin-left: auto;
  border-width: 0 1.5px 1.5px 0;
  border-style: solid;
  border-color: var(--chaek-color-text-primary);
  content: '';
  transform: translateY(-2px) rotate(45deg);
}

.Select-module__root--KcD4h:not(li):focus {
  outline: 0;
}

.Select-module__root--KcD4h:not(li):focus-within .Select-module__box--LTGr8 {
  border-color: var(--chaek-color-border-strong);
}

.Select-module__is-placeholder--DozWm:not(li) {
  color: var(--chaek-color-text-placeholder);
}

.Select-module__is-disabled--KDTRW:not(li) {
  opacity: 0.4;
}

.Select-module__is-disabled--KDTRW:not(li) .Select-module__box--LTGr8 {
  cursor: not-allowed;
}

.Select-module__root--KcD4h.Select-module__size-small--vFEi7:not(li) {
  height: 44px;
}

.Select-module__root--KcD4h.Select-module__size-medium--DwlZr:not(li) {
  height: 50px;
}

.Select-module__root--KcD4h.Select-module__size-large--Xe28Q:not(li) {
  height: 56px;
}

.Select-module__container--nrIWZ {
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 0;
  display: none;
  min-width: 100%;
  overflow: hidden;
  border: 1px solid var(--chaek-color-border-source-e0e0e3);
  border-radius: 12px;
  background-color: var(--chaek-color-surface-canvas);
}

.Select-module__root--KcD4h:not(li):not(.Select-module__is-disabled--KDTRW):hover .Select-module__container--nrIWZ,
.Select-module__root--KcD4h:not(li):not(.Select-module__is-disabled--KDTRW):focus-within .Select-module__container--nrIWZ {
  display: block;
}

.Select-module__container--nrIWZ ul {
  padding: 8px;
  margin: 0;
  list-style: none;
}

.Select-module__container--nrIWZ li {
  box-sizing: border-box;
  display: flex;
  min-height: 48px;
  align-items: center;
  padding-inline: 12px;
  border-radius: 6px;
  color: var(--chaek-color-text-primary);
  font-size: 1rem; /* 16px */
  line-height: 21px;
  white-space: nowrap;
  cursor: pointer;
}

.Select-module__container--nrIWZ li:hover,
.Select-module__container--nrIWZ li.Select-module__is-active--WQgyX {
  background-color: #fff4df;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Select/Select.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sCAAsC;EACtC,iDAAiD;EACjD,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,MAAM;EACN,mBAAmB;EACnB,kBAAkB;EAClB,yDAAyD;EACzD,oBAAoB;EACpB,mDAAmD;EACnD,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yDAAyD;EACzD,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe,EAAE,SAAS;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":[".root:not(li) {\n  position: relative;\n  display: inline-flex;\n  min-width: 108px;\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: 0;\n}\n\n.root:not(li)::after {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  left: 0;\n  height: 4px;\n  content: '';\n}\n\n.box {\n  box-sizing: border-box;\n  display: inline-flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  gap: 0;\n  padding-right: 10px;\n  padding-left: 14px;\n  border: 1px solid var(--chaek-color-border-source-e0e0e3);\n  border-radius: 999px;\n  background-color: var(--chaek-color-surface-canvas);\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.box::after {\n  width: 7px;\n  height: 7px;\n  margin-right: 5.5px;\n  margin-left: auto;\n  border-width: 0 1.5px 1.5px 0;\n  border-style: solid;\n  border-color: var(--chaek-color-text-primary);\n  content: '';\n  transform: translateY(-2px) rotate(45deg);\n}\n\n.root:not(li):focus {\n  outline: 0;\n}\n\n.root:not(li):focus-within .box {\n  border-color: var(--chaek-color-border-strong);\n}\n\n.is-placeholder:not(li) {\n  color: var(--chaek-color-text-placeholder);\n}\n\n.is-disabled:not(li) {\n  opacity: 0.4;\n}\n\n.is-disabled:not(li) .box {\n  cursor: not-allowed;\n}\n\n.root.size-small:not(li) {\n  height: 44px;\n}\n\n.root.size-medium:not(li) {\n  height: 50px;\n}\n\n.root.size-large:not(li) {\n  height: 56px;\n}\n\n.container {\n  position: absolute;\n  z-index: 10;\n  top: 100%;\n  left: 0;\n  display: none;\n  min-width: 100%;\n  overflow: hidden;\n  border: 1px solid var(--chaek-color-border-source-e0e0e3);\n  border-radius: 12px;\n  background-color: var(--chaek-color-surface-canvas);\n}\n\n.root:not(li):not(.is-disabled):hover .container,\n.root:not(li):not(.is-disabled):focus-within .container {\n  display: block;\n}\n\n.container ul {\n  padding: 8px;\n  margin: 0;\n  list-style: none;\n}\n\n.container li {\n  box-sizing: border-box;\n  display: flex;\n  min-height: 48px;\n  align-items: center;\n  padding-inline: 12px;\n  border-radius: 6px;\n  color: var(--chaek-color-text-primary);\n  font-size: 1rem; /* 16px */\n  line-height: 21px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.container li:hover,\n.container li.is-active {\n  background-color: #fff4df;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Select-module__root--KcD4h`,
	"box": `Select-module__box--LTGr8`,
	"is-placeholder": `Select-module__is-placeholder--DozWm`,
	"is-disabled": `Select-module__is-disabled--KDTRW`,
	"size-small": `Select-module__size-small--vFEi7`,
	"size-medium": `Select-module__size-medium--DwlZr`,
	"size-large": `Select-module__size-large--Xe28Q`,
	"container": `Select-module__container--nrIWZ`,
	"is-active": `Select-module__is-active--WQgyX`
};
export default ___CSS_LOADER_EXPORT___;
